import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import Navigation from "./navigator/navigation";
import { Container } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { AppContext, AppProvider } from "./config/Context";
import ProtectedRoute from "./navigator/ProtectedRoute";
import SimpleReactLightbox from "simple-react-lightbox";
import HttpsRedirect from 'react-https-redirect';

import Login from "./screens/Login";
import Issue from "./screens/Issue";
import Farmer from "./screens/Farmer";
import Crop from "./screens/Crop";
import AddIssue from "./screens/Issue/addIssue";
import ViewIssue from "./screens/Issue/viewIssue";
import AddFarmer from "./screens/Farmer/addFarmer";
import ViewFarmer from "./screens/Farmer/viewFarmer";
import ProductsandLabels from "./screens/ProductsandLabels";
import SignUp from "./screens/SignUp";
import Staff from "./screens/Staff";
import Shop from "./screens/Dealer";
import Reports from "./screens/Reports";
import CommodityNews from "./screens/CommodityNews";
import ChatBot from "./components/ChatBot/ChatBot";

const dotenv = require("dotenv");
axios.interceptors.request.use(
  function (successfulReq) {
    const noAuthSegments = ["login", "send-otp", "verify-otp"];
    if (!noAuthSegments.includes(successfulReq.url.split("/").pop())) {
      successfulReq.headers.Authorization = localStorage.getItem("accessToken");
    }
    return Promise.resolve(successfulReq);
  },
  function (error) {
    return Promise.reject(error);
  }
);

const AppFooter = () => (
  <footer style={{
    backgroundColor: '#1a3328',
    borderTop: '2px solid #2d5a3d',
    padding: '0.9rem 1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    flexWrap: 'wrap',
  }}>
    <span style={{ fontSize: '0.78rem', fontWeight: 500, color: 'rgba(232,240,235,0.75)', letterSpacing: '0.02em' }}>
      © 2026 Manshya Academy. All rights reserved.
    </span>
    <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '0.75rem' }}>·</span>
    <span style={{ fontSize: '0.78rem', fontWeight: 500, color: 'rgba(232,240,235,0.75)', letterSpacing: '0.02em' }}>
      Made with <span style={{ color: '#e74c3c', fontSize: '0.85rem' }}>♥</span> in India
    </span>
  </footer>
);

function App() {
  const isAdmin = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user")).role
        ? JSON.parse(localStorage.getItem("user")).role == "admin"
          ? true
          : false
        : false
      : false
    : false;

  return (
    <>
    <HttpsRedirect>
    <SimpleReactLightbox>
      <AppProvider>
        <Switch>
            <Route
              path="/farmer"
              exact
              render={() => <ProtectedRoute path="/farmer" exact={true} component={Farmer} />}
            />
            <Route path="/crop" exact render={() => <ProtectedRoute path="/crop" exact={true} component={Crop} />} />
            <Route
              path="/addIssue/:mobileNumber"
              exact
              render={() => <ProtectedRoute path="/addIssue/:mobileNumber" exact={true} component={AddIssue} />}
            />
            <Route
              path="/viewIssue/:issueCode"
              exact
              render={() => (
                <ProtectedRoute path="/viewIssue/:issueCode" exact={true} component={withRouter(ViewIssue)} />
              )}
            />
            <Route
              path="/viewFarmer/:mobileNumber"
              exact
              render={() => <ProtectedRoute path="/viewFarmer/:mobileNumber" exact={true} component={ViewFarmer} />}
            />
            <Route
              path="/addFarmer"
              exact
              render={() => <ProtectedRoute path="/addFarmer" exact={true} component={AddFarmer} />}
            />
            <Route
              path="/productAndLabel"
              exact
              render={() => <ProtectedRoute path="/productAndLabel" exact={true} component={ProductsandLabels} />}
            />
            <Route
              path="/commodity-news"
              exact
              render={() => <ProtectedRoute path="/commodity-news" exact={true} component={CommodityNews} />}
            />
            <Route
              path="/reports"
              exact
              render={() => <ProtectedRoute path="/reports" exact={true} component={Reports} />}
            />
            <Route
              path="/signUp"
              exact
              render={() =>
                isAdmin ? (
                  <ProtectedRoute path="/signUp" exact={true} component={SignUp} />
                ) : (
                  <Redirect to={{ pathname: "/" }} />
                )
              }
            />
            <Route
              path="/administration/staff"
              exact
              render={() =>
                isAdmin ? (
                  <ProtectedRoute path="/administration/staff" exact={true} component={Staff} />
                ) : (
                  <Redirect to={{ pathname: "/" }} />
                )
              }
            />
            <Route
              path="/administration/dealer"
              exact
              render={() =>
                isAdmin ? (
                  <ProtectedRoute path="/administration/dealer" exact={true} component={Shop} />
                ) : (
                  <Redirect to={{ pathname: "/" }} />
                )
              }
            />
            <Route path="/" exact render={() => <ProtectedRoute path="/" exact={true} component={Issue} />} />
            <Route path="/login"  component={Login} />
        </Switch>
        {!!localStorage.getItem("accessToken") && <AppFooter />}
        {!!localStorage.getItem("accessToken") && <ChatBot />}
      </AppProvider>
      </SimpleReactLightbox>
      </HttpsRedirect>
    </>
  );
}

export default App;
